/* Shared FCC stamp-in: used by m1v2-hero, m1v2-capabilities (any [data-fcc-stamp]). */
(function () {
  var stamps = document.querySelectorAll('[data-fcc-stamp]');
  if (!stamps.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyStamp(el) {
    if (el.classList.contains('is-stamped')) return;
    var delay = parseInt(el.getAttribute('data-fcc-delay') || '0', 10);
    if (reduceMotion || !delay) {
      el.classList.add('is-stamped');
      return;
    }
    window.setTimeout(function () {
      el.classList.add('is-stamped');
    }, delay);
  }

  var autoStamps = [];
  stamps.forEach(function (el) {
    if (el.hasAttribute('data-fcc-manual')) return;
    autoStamps.push(el);
  });
  if (!autoStamps.length) return;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    autoStamps.forEach(applyStamp);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        applyStamp(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
  );

  autoStamps.forEach(function (el) {
    observer.observe(el);
  });
})();
